/**
 * 上传组件封装
 * */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../WithRouterHOC';
import { message, Upload } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

class CusUpload extends PureComponent {
  state = {
    loading: false,
  };
  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  // 上传图片之前
  beforeUpload = (file) => {
    return new Promise((resolve, reject) => {
      const { loading } = this.state;
      if (loading) {
        message.warning(`图片正在上传中，请等待结果`);
        resolve(false);
      }
      const { size } = this.props;
      if (size && file.size > 1024 * 1024 * size) {
        message.error(`上传失败，图片大小不能超过${size}MB`);
        reject(false);
      }
      resolve(true);
    });
  };
  // 上传图片
  changeUpload = (info) => {
    const { onChange } = this.props;
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
    } else if (info.file.status === 'done') {
      const res = info.file.response;
      if (res.code === 200) {
        onChange && onChange(res.data, info);
      } else {
        message.error((res && res.message) || '上传失败，请稍候重试');
      }
      this.setState({ loading: false });
    } else if (info.file.status === 'error') {
      message.error('上传失败，请稍后重试~');
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading } = this.state;
    let { base, children, changeUpload, beforeUpload, onPreview, privateType } =
      this.props;
    const uploadProps = {
      name: 'file',
      accept: '.jpg,.png',
      action:
        base.rootConfig.ctxPath +
        '/file/api/base/upload' +
        (privateType ? '?privateType=1' : ''),
      showUploadList: false,
      headers: {
        authorization: base.token,
        uid: base.uid,
      },
      ...this.props,
    };
    if (!changeUpload) {
      changeUpload = this.changeUpload;
    }
    if (!beforeUpload) {
      beforeUpload = this.beforeUpload;
    }

    return (
      <Upload
        {...uploadProps}
        onChange={changeUpload}
        beforeUpload={beforeUpload}
        onPreview={onPreview}
      >
        {loading ? <LoadingOutlined /> : children}
      </Upload>
    );
  }
}

CusUpload.defaultProps = {
  config: {},
  size: 2, // 限制图片储存大小
  onChange: null, // 上传成功后回调的数据
  changeUpload: null, // 上传图片回调函数
  privateType: 0, // 是否私有文件
};

export default connect((store) => ({ base: store }))(
  withRouter(CusUpload, { withRef: true })
);
